export const PART_PALLET: CurationPartDefinition[] = [
  {
    type: 'jps-curation-text',
    ja: {
      ops: [
        {
          insert: '\n'
        }
      ]
    },
    en: {
      ops: [
        {
          insert: '\n'
        }
      ]
    }
  },
  {
    type: 'jps-curation-image',
    image: {},
    caption: {},
    description: {}
  },
  {
    type: 'jps-curation-list',
    title: {
      ja: '',
      en: ''
    },
    viewType: 'tile',
    parts: [],
    openActionType: 'link'
  },
  {
    type: 'jps-curation-search-box',
    mode: 'NORMAL'
  },
  {
    type: 'jps-curation-image-annotation',
    parts: []
  },
  {
    type: 'jps-curation-timeline',
    parts: [],
    timeline: {
      start: 0,
      end: 0
    },
    layout: 'bar'
  },
  {
    type: 'jps-curation-section',
    title: {},
    parts: []
  },
  {
    type: 'jps-curation-index',
    style: 'normal'
  },
  {
    type: 'jps-curation-subpage-list'
  },
  {
    type: 'jps-curation-iframe',
    caption: {},
    description: {},
    layout: 'bottom_description'
  },
  {
    type: 'jps-curation-tab'
  }
]
export const LIST_PALLET: CurationPartDefinition[] = [
  {
    type: 'jps-curation-list-item'
  },
  {
    type: 'jps-curation-list-curation'
  },
  {
    type: 'jps-curation-list-database'
  },
  {
    type: 'jps-curation-list-organization'
  },
  {
    type: 'jps-curation-list-csearch'
  },
  {
    type: 'jps-curation-list-search-result'
  },
  {
    type: 'jps-curation-list-external-link'
  }
]
export const CURATION_TEMPLATE: any[] = [
  {
    id: 'tp-search',
    parts: [
      {
        type: 'jps-curation-section',
        title: {
          ja: '検索画面タイトル'
        },
        parts: [
          {
            type: 'jps-curation-text',
            ja: {
              ops: [
                {
                  insert: 'この検索画面の説明等を記入。'
                }
              ]
            }
          },
          {
            type: 'jps-curation-search-box',
            mode: 'NORMAL'
          }
        ]
      }
    ]
  },
  {
    id: 'tp-holdings',
    parts: [
      {
        type: 'jps-curation-section',
        title: {
          ja: '所蔵資料紹介'
        },
        parts: [
          {
            type: 'jps-curation-text',
            ja: {
              ops: [
                {
                  insert: '○○の代表的な所蔵資料を紹介します。'
                }
              ]
            }
          },
          {
            type: 'jps-curation-list',
            title: {
              ja: '代表的な所蔵資料（画像＋解説）'
            },
            viewType: 'image',
            parts: [
              {
                type: 'jps-curation-list-item',
                description: {
                  ja: '資料の解説'
                }
              },
              {
                type: 'jps-curation-list-item',
                description: {
                  ja: '資料の解説'
                }
              }
            ]
          },
          {
            type: 'jps-curation-list',
            title: {
              ja: '代表的な所蔵資料（タイル表示、個別解説なし）'
            },
            viewType: 'tile',
            parts: [
              {
                type: 'jps-curation-list-item'
              },
              {
                type: 'jps-curation-list-item'
              }
            ]
          },
          {
            type: 'jps-curation-text',
            ja: {
              ops: [
                {
                  insert: 'その他、○○をテーマにした所蔵資料を紹介します。'
                }
              ]
            }
          },
          {
            type: 'jps-curation-list',
            title: {
              ja: 'その他の所蔵資料（1～3件目は手動で選択、4件目以降は横断検索/テーマ別検索の検索結果を表示）'
            },
            viewType: 'card',
            parts: [
              {
                type: 'jps-curation-list-item'
              },
              {
                type: 'jps-curation-list-item'
              },
              {
                type: 'jps-curation-list-item'
              },
              {
                type: 'jps-curation-list-search-result'
              }
            ]
          }
        ]
      },
      {
        type: 'jps-curation-list',
        title: {
          ja: '参考リンク'
        },
        viewType: 'bullet',
        parts: [
          {
            type: 'jps-curation-list-external-link',
            title: {
              ja: 'リンク名'
            },
            description: {
              ja: 'リンク説明'
            }
          },
          {
            type: 'jps-curation-list-external-link',
            title: {
              ja: 'リンク名'
            },
            description: {
              ja: 'リンク説明'
            }
          }
        ]
      },
      {
        type: 'jps-curation-list',
        title: {
          ja: '出典等'
        },
        viewType: 'reference',
        parts: [
          {
            type: 'jps-curation-list-item'
          },
          {
            type: 'jps-curation-list-item'
          },
          {
            type: 'jps-curation-list-item'
          }
        ]
      }
    ]
  }
]
